import styled from 'styled-components';

export const Container = styled.div`
  header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    padding: 10px;
    z-index: 99;
    position: relative;

    h1 {
      color: #00a859;
      font-weight: 600;
    }

    nav {
      button {
        border: 1px solid #00a859;
        background-color: transparent;
        border-radius: 4px;
        color: #171412;
        font-weight: 600;
        font-family: 'Poppins';
        height: 40px;
        padding-left: 8px;
        padding-right: 8px;
      }

      > button {
        margin-left: 10px;
      }

      & :hover {
        cursor: pointer;
        color: #00a859;
      }
    }
  } /* END HEADER */

  #buttonReportHolder {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #pageTitle {
    justify-content: center;
    text-align: center;
    color: #00a859;
    font-weight: 600;
    margin: 0 auto;

    :after {
      display: block;
      text-align: center;
      margin: 0 auto;
      content: '';
      width: 40%;
      border-bottom: 3px solid #00a859;
      animation: 1s ease-in 0s 1 slideInFromLeft;
    }

    @keyframes slideInFromLeft {
      0% {
        transform: translateX(-40%);
      }
      100% {
        transform: translateX(0);
      }
    }
  }

  /* titulo saldo pedidos - Table */
  h4 {
    display: flex;
    justify-content: center;
    color: #00a859;
    font-weight: 600;
    margin-top: 30px;
  }
`;

export const TableContainer = styled.section`
  max-height: calc(100vh - 155px) !important;
  padding-bottom: 3rem;
  margin-top: 2.5rem;

  width: 100% !important;
  overflow-y: auto;
  overflow-x: hidden;

  padding-left: 20px;
  padding-right: 20px;

  table {
    width: 100%;
    height: 100%;
    border-spacing: 0 8px;
    white-space: nowrap;
    justify-content: center;
    border-collapse: collapse;
    margin-top: 1rem;

    thead th {
      height: 40px;
      top: 0;
      position: sticky;
      background: #fff;
    }

    #nullPedidos {
      border: 1px solid red;
    }

    th {
      text-align: center;
    }

    td {
      padding: 8px 0px;
      border: 0;
      background: #fff;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      color: #969cb3;
      border-bottom: 1px solid #969cb3;

      &.vPedTransp {
        width: 300px;
      }

      &.vPedTipo {
        width: 150px;
      }

      &.vPedVolMax {
        width: 200px;
      }

      &.vPedStatus {
        width: 200px;
      }

      &.vPedActions {
        width: 140px;
      }

      /* Edit and Delete Button */
      button {
        border: transparent;
        background: none;
        margin-right: 10px;

        svg {
          display: flex;
        }
      }
    }

    td:first-child {
      border-radius: 8px 0 0 8px;
    }

    td:last-child {
      border-radius: 0 8px 8px 0;
    }
  }

  /* *********************Media 1400*********************************** */
  @media (max-width: 1400px) {
    max-height: 400px !important;
    margin-top: 0px;

    table {
      width: 100%;
      height: 100%;
      border-spacing: 0 8px;
      white-space: nowrap;
      justify-content: center;
      border-collapse: collapse;

      thead th {
        height: 30px;
        top: 0;
        position: sticky;
        background: #fff;
      }

      #nullPedidos {
        border: 1px solid red;
      }

      th {
        text-align: center;
        font-size: 12px;
      }

      td {
        padding: 8px 0px;
        border: 0;
        background: #fff;
        text-align: center;
        font-size: 12px;
        font-weight: 600;
        color: #969cb3;
        border-bottom: 1px solid #969cb3;

        &.vPedTransp {
          width: 120px;
        }

        &.vPedTipo {
          width: 90px;
        }

        &.vPedVolMax {
          width: 110px;
        }

        &.vPedStatus {
          width: 290px;
        }

        &.vPedActions {
          width: 140px;
        }

        /* Edit and Delete Button */
        button {
          border: transparent;
          background: none;
          margin-right: 10px;

          svg {
            display: flex;
          }
        }
      }

      td:first-child {
        border-radius: 8px 0 0 8px;
      }

      td:last-child {
        border-radius: 0 8px 8px 0;
      }
    }
  }
  /* ***************************************************************** */
`;
